export default function FakeRateTrendPage() {
  return (
    <div className="style_rateTrendContainer__rbIP8">
      <form className="style_rateTrendForm__qOz7G">
        <div className="style_rateTrendBox__6v1yJ">
          <div className="style_googleAutocompleteContainer__owx5N flex-1">
            <div className="style_googleAutocompleteLabel__xX0MD text-tertiary">
              &nbsp;&nbsp;Origin
            </div>
            <div className="style_googleAutocompleteInputWrapper__QNxrk">
              <input
                type="text"
                placeholder=""
                className="style_googleAutocompleteInput__hVtcC bg-input pac-target-input"
                value="Los Angeles, CA, USA"
                autoComplete="off"
              />
            </div>
          </div>
          <div className="style_googleAutocompleteContainer__owx5N flex-1">
            <div className="style_googleAutocompleteLabel__xX0MD text-tertiary">
              &nbsp;&nbsp;Destination
            </div>
            <div className="style_googleAutocompleteInputWrapper__QNxrk">
              <input
                type="text"
                placeholder=""
                className="style_googleAutocompleteInput__hVtcC bg-input pac-target-input"
                value="San Bernardino, CA, USA"
                autoComplete="off"
              />
            </div>
          </div>
          <div className="style_selectContainer__XifT7">
            <label className="style_selectLabel__mbvF7 text-tertiary">&nbsp;&nbsp;Equipment</label>
            <div className="style_selectWrapper__PYbyu" data-headlessui-state="">
              <button
                className="style_selectButton__6QXVt bg-input"
                id="headlessui-listbox-button-:rn:"
                type="button"
                aria-haspopup="listbox"
                aria-expanded="false"
                data-headlessui-state="">
                Dry Van
                <svg viewBox="0 0 24 24" role="presentation" className="style_selectArrow__IUb5e">
                  <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="style_smartButton__Lpxnl style_smartButtonContained__W4w18 h-11 px-5 justify-center rounded-base style_rateTrendButton__swxVr disabled:!bg-subtitle">
          Submit
        </button>
      </form>
      <div className="style_rateTrendWrapper__J3bpS">
        <div className="style_rateTrendState__9YVds">
          <ul className="style_rateTrendStateList__40PNF">
            <li className="rounded-t-base">
              <span className="w-2/3">Avg. Linehaul Rate:</span>
              <span>$686.82</span>
            </li>
            <li>
              <span className="w-2/3">Avg. Rate Per Mile:</span>
              <span>$11.52</span>
            </li>
            <li>
              <span className="w-2/3">Estimated Fuel Cost:</span>
              <span>$34.82</span>
            </li>
            <li>
              <span className="w-2/3">Estimated Revenue:</span>
              <span>$652.00</span>
            </li>
            <li className="rounded-b-base">
              <span className="w-2/3">Distance:</span>
              <span>60mi</span>
            </li>
          </ul>
        </div>
        <div className="style_rateTrendLaneTrends__BgK22">
          <h3 className="text-2xl font-medium">Lane Trends</h3>
          <ul className="style_rateTrendLaneTrendList__5hEoZ">
            <li className="style_rateTrendLanesBody__x8-XB">
              <div>
                <div className="style_rateTrendLanesRow__G2qFF">
                  <span>FONTANA, CA</span>
                  <svg width="29" height="8" viewBox="0 0 29 8" className="w-fit">
                    <circle cx="4" cy="4" r="4" fill="currentColor"></circle>
                    <path
                      d="M28.3536 4.35356C28.5488 4.15829 28.5488 3.84171 28.3536 3.64645L25.1716 0.464468C24.9763 0.269206 24.6597 0.269206 24.4645 0.464468C24.2692 0.65973 24.2692 0.976313 24.4645 1.17157L27.2929 4L24.4645 6.82843C24.2692 7.02369 24.2692 7.34027 24.4645 7.53554C24.6597 7.7308 24.9763 7.7308 25.1716 7.53554L28.3536 4.35356ZM4 4.5L28 4.5L28 3.5L4 3.5L4 4.5Z"
                      fill="currentColor"></path>
                  </svg>
                  <span>COACHELLA, CA</span>
                </div>
                <span className="ml-auto">48 ft</span>
              </div>
              <div>
                <span>$600.00</span>
                <span className="ml-auto">42000 lbs</span>
              </div>
              <div className="text-placeholder">
                <span>Dry Van (V)</span>
                <span className="ml-auto">Jan 02</span>
              </div>
            </li>
            <li className="style_rateTrendLanesBody__x8-XB">
              <div>
                <div className="style_rateTrendLanesRow__G2qFF">
                  <span>SANTA CLARITA, CA</span>
                  <svg width="29" height="8" viewBox="0 0 29 8" className="w-fit">
                    <circle cx="4" cy="4" r="4" fill="currentColor"></circle>
                    <path
                      d="M28.3536 4.35356C28.5488 4.15829 28.5488 3.84171 28.3536 3.64645L25.1716 0.464468C24.9763 0.269206 24.6597 0.269206 24.4645 0.464468C24.2692 0.65973 24.2692 0.976313 24.4645 1.17157L27.2929 4L24.4645 6.82843C24.2692 7.02369 24.2692 7.34027 24.4645 7.53554C24.6597 7.7308 24.9763 7.7308 25.1716 7.53554L28.3536 4.35356ZM4 4.5L28 4.5L28 3.5L4 3.5L4 4.5Z"
                      fill="currentColor"></path>
                  </svg>
                  <span>RIALTO, CA</span>
                </div>
                <span className="ml-auto">48 ft</span>
              </div>
              <div>
                <span>$600.00</span>
                <span className="ml-auto">42000 lbs</span>
              </div>
              <div className="text-placeholder">
                <span>Dry Van (V)</span>
                <span className="ml-auto">Jan 02</span>
              </div>
            </li>
            <li className="style_rateTrendLanesBody__x8-XB">
              <div>
                <div className="style_rateTrendLanesRow__G2qFF">
                  <span>SANTA CLARITA, CA</span>
                  <svg width="29" height="8" viewBox="0 0 29 8" className="w-fit">
                    <circle cx="4" cy="4" r="4" fill="currentColor"></circle>
                    <path
                      d="M28.3536 4.35356C28.5488 4.15829 28.5488 3.84171 28.3536 3.64645L25.1716 0.464468C24.9763 0.269206 24.6597 0.269206 24.4645 0.464468C24.2692 0.65973 24.2692 0.976313 24.4645 1.17157L27.2929 4L24.4645 6.82843C24.2692 7.02369 24.2692 7.34027 24.4645 7.53554C24.6597 7.7308 24.9763 7.7308 25.1716 7.53554L28.3536 4.35356ZM4 4.5L28 4.5L28 3.5L4 3.5L4 4.5Z"
                      fill="currentColor"></path>
                  </svg>
                  <span>RIALTO, CA</span>
                </div>
                <span className="ml-auto">48 ft</span>
              </div>
              <div>
                <span>$600.00</span>
                <span className="ml-auto">42000 lbs</span>
              </div>
              <div className="text-placeholder">
                <span>Dry Van (V)</span>
                <span className="ml-auto">Jan 02</span>
              </div>
            </li>
            <li className="style_rateTrendLanesBody__x8-XB">
              <div>
                <div className="style_rateTrendLanesRow__G2qFF">
                  <span>SANTA CLARITA, CA</span>
                  <svg width="29" height="8" viewBox="0 0 29 8" className="w-fit">
                    <circle cx="4" cy="4" r="4" fill="currentColor"></circle>
                    <path
                      d="M28.3536 4.35356C28.5488 4.15829 28.5488 3.84171 28.3536 3.64645L25.1716 0.464468C24.9763 0.269206 24.6597 0.269206 24.4645 0.464468C24.2692 0.65973 24.2692 0.976313 24.4645 1.17157L27.2929 4L24.4645 6.82843C24.2692 7.02369 24.2692 7.34027 24.4645 7.53554C24.6597 7.7308 24.9763 7.7308 25.1716 7.53554L28.3536 4.35356ZM4 4.5L28 4.5L28 3.5L4 3.5L4 4.5Z"
                      fill="currentColor"></path>
                  </svg>
                  <span>MIRA LOMA, CA</span>
                </div>
                <span className="ml-auto">48 ft</span>
              </div>
              <div>
                <span>$600.00</span>
                <span className="ml-auto">44000 lbs</span>
              </div>
              <div className="text-placeholder">
                <span>Dry Van (V)</span>
                <span className="ml-auto">Jan 02</span>
              </div>
            </li>
            <li className="style_rateTrendLanesBody__x8-XB">
              <div>
                <div className="style_rateTrendLanesRow__G2qFF">
                  <span>SANTA CLARITA, CA</span>
                  <svg width="29" height="8" viewBox="0 0 29 8" className="w-fit">
                    <circle cx="4" cy="4" r="4" fill="currentColor"></circle>
                    <path
                      d="M28.3536 4.35356C28.5488 4.15829 28.5488 3.84171 28.3536 3.64645L25.1716 0.464468C24.9763 0.269206 24.6597 0.269206 24.4645 0.464468C24.2692 0.65973 24.2692 0.976313 24.4645 1.17157L27.2929 4L24.4645 6.82843C24.2692 7.02369 24.2692 7.34027 24.4645 7.53554C24.6597 7.7308 24.9763 7.7308 25.1716 7.53554L28.3536 4.35356ZM4 4.5L28 4.5L28 3.5L4 3.5L4 4.5Z"
                      fill="currentColor"></path>
                  </svg>
                  <span>MIRA LOMA, CA</span>
                </div>
                <span className="ml-auto">48 ft</span>
              </div>
              <div>
                <span>$600.00</span>
                <span className="ml-auto">44000 lbs</span>
              </div>
              <div className="text-placeholder">
                <span>Dry Van (V)</span>
                <span className="ml-auto">Jan 02</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
